import { Model } from "./model";

export class AAQuestionnaireAnswer extends Model {
	private label: string = "";
	private answer: string = "";
	private valid: boolean = false;
	private selected: boolean = false;

	public getLabel(): string {
		return this.label;
	}

	public getAnswer(): string {
		return this.answer;
	}

	public setAnswer(a: string): void {
		this.answer = a;
	}

	public isValid(): boolean {
		return this.valid;
	}

	public isSelected(): boolean {
		return this.selected;
	}

	public setSelected(b: boolean): void {
		this.selected = b;
	}
}
